/**
 * The creature's round bubble: the physics circle made visible, as a see-through glass gem
 * bubble (the candy kit's drawDiscCandy / discShineCandy). Tinted glass deepening toward a
 * coloured rim, a refraction caustic lower right, a window reflection and glint on top, so
 * every creature reads as the same kind of round, bumpable thing.
 *
 * The disc also carries the chain's rarity ladder, so a later tier looks like a better prize:
 *   tiers 0–3  plain water: bubbles;
 *   tiers 4–7  garden: flowers, leaves, a pastel rainbow in the glass;
 *   tiers 8–9  special: rays, gem facets and sparkles;
 *   tier 10    the Dragon: a studded gold band (tone.band "gold") in place of the rim.
 * Neighbouring tiers differ in glass hue or value, so 30 px ring chips never pair up.
 */
import { drawDiscCandy, discShineCandy } from "./candy-kit.js";

/**
 * @param {CanvasRenderingContext2D} c
 * @param {number} r disc radius
 * @param {{ base: string, light: string, shade: string, ink?: string, band?: string, alpha?: number }} tone
 *   ink: rim colour (defaults to a deep shade of `shade`); band "gold": studded gold band
 * @param {{ pattern?: (c: CanvasRenderingContext2D, r: number) => void }} [opts]
 */
export function drawDisc(c, r, tone, opts) {
  drawDiscCandy(c, r, tone, opts);
}

/** The bubble's window reflection and glint, painted over the creature. */
export function discShine(c, r) {
  discShineCandy(c, r);
}
